module.exports = __webpack_public_path__ + "static/media/session2.2a098023.png";